<ds-currency-input
  class="w-100"
  [formControl]="formControl"
  [label]="props.label || 'Amount'"
  [helper]="helper"
  [error]="error"
  [placeholder]="props.placeholder || '0.00'"
  [inputId]="id"
/>
<formly-validation-message *ngIf="showError" class="d-none" [field]="field" />
